import React from 'react';

import { ReactComponent as AccessWorldwide } from '@shipstation/svgs/src/svgs/access-worldwide.svg';
import { ReactComponent as Apc } from '@shipstation/svgs/src/svgs/apc.svg';
import { ReactComponent as Asendia } from '@shipstation/svgs/src/svgs/asendia.svg';
import { ReactComponent as AustraliaPost } from '@shipstation/svgs/src/svgs/australia-post.svg';
import { ReactComponent as CanadaPost } from '@shipstation/svgs/src/svgs/canada-post.svg';
import { ReactComponent as DhlExpress } from '@shipstation/svgs/src/svgs/dhl-express.svg';
import { ReactComponent as Fedex } from '@shipstation/svgs/src/svgs/fedex.svg';
import { ReactComponent as FirstMile } from '@shipstation/svgs/src/svgs/first-mile.svg';
import { ReactComponent as Globegistics } from '@shipstation/svgs/src/svgs/globegistics.svg';
import { ReactComponent as Imex } from '@shipstation/svgs/src/svgs/imex.svg';
import { ReactComponent as Newgistics } from '@shipstation/svgs/src/svgs/newgistics.svg';
import { ReactComponent as Ontrac } from '@shipstation/svgs/src/svgs/ontrac.svg';
import { ReactComponent as Purolator } from '@shipstation/svgs/src/svgs/purolator.svg';
import { ReactComponent as RrDonnelley } from '@shipstation/svgs/src/svgs/rr-donnelley.svg';
import { ReactComponent as Sendle } from '@shipstation/svgs/src/svgs/sendle.svg';
import { ReactComponent as UnknownProvider } from '@shipstation/svgs/src/svgs/unknown-provider.svg';
import { ReactComponent as Ups } from '@shipstation/svgs/src/svgs/ups.svg';
import { ReactComponent as Usps } from '@shipstation/svgs/src/svgs/usps.svg';

import { useTrackingData } from './DataProviders';

import styles from './CarrierIcon.module.css';


const svgsAsComponents = {
  'usps': Usps,
  'stamps_com': UnknownProvider,
  'fedex': Fedex,
  'ups': Ups,
  'dhl_express': DhlExpress,
  'canada_post': CanadaPost,
  'australia_post': AustraliaPost,
  'firstmile': FirstMile,
  'asendia': Asendia,
  'ontrac': Ontrac,
  'apc': Apc,
  'newgistics': Newgistics,
  'globegistics': Globegistics,
  'rr_donnelley': RrDonnelley,
  'imex': Imex,
  'access_worldwide': AccessWorldwide,
  'purolator_ca': Purolator,
  'sendle': Sendle,
  'unknown_provider': UnknownProvider,
};


export default function CarrierIcon({ className='' }) {
  const { carrier } = useTrackingData();

  if( !carrier ) {
    return null;
  }

  const Svg = svgsAsComponents[carrier] || svgsAsComponents['unknown_provider'];
  return <Svg className={`${styles.carrierIcon} ${className}`} />;
}
